<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="mb-2">
            <div class="dropdown">
              <a
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    @click.prevent="exportCsv"
                    v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as CSV
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    @click.prevent="exportPdf"
                    v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="head-icons ms-2">
            <a id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="row dq-stat-grid">
        <!-- KPI Cards -->
        <div class="col-xl-6 d-flex">
          <div class="row flex-fill">
            <div v-for="c in kpiCards" :key="c.title" class="col-md-6 d-flex">
              <div class="card flex-fill dq-stat-card">
                <div class="card-body">
                  <div
                    class="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2"
                  >
                    <div>
                      <span class="fs-14 fw-normal text-truncate mb-1">
                        {{ c.title }}
                      </span>
                      <h5 v-if="c.type === 'money'">
                        {{ currency }}
                        {{
                          Number(c.value).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })
                        }}
                      </h5>
                      <h5 v-else>
                        {{ c.value }}
                      </h5>
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="avatar avatar-md avatar-rounded"
                      :class="`bg-transparent-${c.cls} border border-${c.cls}`"
                    >
                      <span :class="`text-${c.cls}`">
                        <i class="ti ti-report-money"></i>
                      </span>
                    </a>
                  </div>
                  <p
                    class="fs-12 fw-normal d-flex align-items-center text-truncate mb-0"
                  >
                    <span class="text-muted">Based on selected period</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Filter (date range) -->
        <div class="col-xl-6 d-flex">
          <div class="card flex-fill">
            <div class="card-header border-0 pb-0">
              <div
                class="d-flex flex-wrap justify-content-between align-items-center row-gap-3"
              >
                <div class="d-flex align-items-center">
                  <span class="me-2">
                    <i class="ti ti-calendar-stats text-primary"></i>
                  </span>
                  <h5>Filter Period</h5>
                </div>
                <div
                  class="input-icon-end position-relative"
                  style="min-width: 230px"
                >
                  <input
                    type="text"
                    class="form-control date-range bookingrange"
                    ref="dateRangeInput"
                    placeholder="dd/mm/yyyy - dd/mm/yyyy"
                  />
                  <span class="input-icon-addon">
                    <i class="ti ti-chevron-down"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="card-body py-3">
              <p class="mb-3 text-muted">
                Showing loans & savings between
                <strong>{{ filters.from }}</strong> and
                <strong>{{ filters.to }}</strong>.
              </p>
              <div class="row g-2 align-items-end">
                <div class="col-12 col-md-6">
                  <label class="form-label mb-1">Search employee</label>
                  <input
                    v-model="filters.search"
                    type="text"
                    class="form-control"
                    placeholder="Name, employee ID, department…"
                    @keyup.enter="applySearch"
                  />
                </div>
                <div class="col-12 col-md-6 d-flex gap-2">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="applySearch"
                  >
                    <i class="ti ti-search me-1"></i> Apply
                  </button>
                  <button
                    type="button"
                    class="btn btn-white border"
                    @click="clearSearch"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Loans &amp; Savings Report</h5>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <LoansSavingsReportTable
              :rows="store.loansSavingsRows"
              :loading="store.loansSavingsLoading"
              :currency="currency"
              :total="store.loansSavingsTotal"
              :page-size="store.loansSavingsPageSize"
              :current="store.loansSavingsCurrent"
              @change="onTableChange"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import DateRangePicker from "daterangepicker";
import moment from "moment";
import { ref, reactive, onMounted, computed } from "vue";
import { useEmployeeSalaryStore } from "@/stores/employeeSalaryStore";
import LoansSavingsReportTable from "./loans-savings-report-table.vue";

const title = "Loans & Savings Report";
const text = "HR";
const text1 = "Loans & Savings";

const store = useEmployeeSalaryStore();

const dateRangeInput = ref(null);

// const filters = reactive({
//   from: moment().startOf("year").format("YYYY-MM"),
//   to: moment().format("YYYY-MM"),
//   page: 1,
//   per_page: 25,
// });

const filters = reactive({
  from: moment().startOf("year").format("YYYY-MM"),
  to: moment().format("YYYY-MM"), // ✅ current month
  search: "",
  page: 1,
  per_page: 25,
});

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function initRangePicker() {
  if (!dateRangeInput.value) return;

  const start = moment(filters.from, "YYYY-MM").startOf("month");
  const end = moment(filters.to, "YYYY-MM").endOf("month");

  const onPick = (s, e) => {
    filters.from = moment(s).format("YYYY-MM");
    filters.to = moment(e).format("YYYY-MM");
    filters.page = 1;
    fetchReport();
  };

  new DateRangePicker(
    dateRangeInput.value,
    {
      startDate: start,
      endDate: end,
      showDropdowns: true,
      autoApply: true,
      ranges: {
        Today: [moment(), moment()],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Year to Date": [moment().startOf("year"), moment().endOf("month")],
        "Last Year": [
          moment().subtract(1, "year").startOf("year"),
          moment().subtract(1, "year").endOf("year"),
        ],
      },
    },
    onPick,
  );
}

async function fetchReport() {
  await store.fetchLoansSavingsReport({
    from: filters.from,
    to: filters.to,
    search: filters.search?.trim() || undefined,
    page: filters.page,
    per_page: filters.per_page,
  });
}

function applySearch() {
  filters.page = 1;
  fetchReport();
}

function clearSearch() {
  filters.search = "";
  filters.page = 1;
  fetchReport();
}

function onTableChange(pagination) {
  filters.page = pagination.current;
  filters.per_page = pagination.pageSize;
  fetchReport();
}

function exportCsv() {
  store.exportLoansSavingsReport("csv", {
    from: filters.from,
    to: filters.to,
    search: filters.search?.trim() || undefined,
  });
}

function exportPdf() {
  store.exportLoansSavingsReport("pdf", {
    from: filters.from,
    to: filters.to,
    search: filters.search?.trim() || undefined,
  });
}

const summary = computed(() => store.loansSavingsSummary || {});
const currency = computed(() => summary.value.currency || "KES");

const kpiCards = computed(() => [
  {
    title: "Total Loans",
    value: summary.value.total_loans || 0,
    cls: "danger",
    type: "money",
  },
  {
    title: "Total Savings",
    value: summary.value.total_savings || 0,
    cls: "success",
    type: "money",
  },
  {
    title: "Total Deductions",
    value: summary.value.total_deductions || 0,
    cls: "warning",
    type: "money",
  },
  {
    title: "Employees in Report",
    value: summary.value.employee_count || 0,
    cls: "primary",
    type: "count",
  },
]);

onMounted(() => {
  initRangePicker();
  fetchReport();
});
</script>

<style scoped>
@media (max-width: 767.98px) {
  .dq-page-actions {
    align-items: stretch !important;
  }

  .dq-page-actions > * {
    width: 100%;
    margin-right: 0 !important;
  }

  .dq-page-actions .dropdown,
  .dq-page-actions .dropdown-toggle {
    width: 100%;
  }

  .dq-stat-card .card-body {
    padding: 1rem;
  }

  .input-icon-end.position-relative {
    min-width: 100% !important;
    width: 100%;
  }

  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style>


